import React from "react";
import LandTypes from './leftMenuComponents/landTypesButton.js';
import PieChart from './leftMenuComponents/pieChartButton.js';
import Modify from './leftMenuComponents/modifyButton.js';
import Drawer from 'react-modern-drawer';
import 'react-modern-drawer/dist/index.css'
import { IoIosArrowBack } from "react-icons/io";
import { IoIosArrowForward } from "react-icons/io";
import { HiClipboardList } from "react-icons/hi";
import { RiPieChartFill } from "react-icons/ri";
import ValueDropdown from './leftMenuComponents/ValueDropdown.js';
import DataDropdown from './leftMenuComponents/dataDropdown.js';
import KeyDropdown from './leftMenuComponents/keyDropdown.js';
import YearDropdown from './leftMenuComponents/yearDropdown.js';
import LandUseButton from "./leftMenuComponents/landUseButton.js";
import CompareButton from "./leftMenuComponents/compareButton.js";
import ClickedInfoRealm from "./leftMenuComponents/clickedInfoRealm.js";
import { isMobile, MobileView, BrowserView, isTablet } from 'react-device-detect';
import { MdLandslide } from "react-icons/md";
import { PiScalesFill } from "react-icons/pi";
import { HiPencil } from "react-icons/hi";
import { Translate } from "@mui/icons-material";
import { MoonLoader } from "react-spinners";
import ConverterPortal from './topSubMenuComponents/converterPortal.js';
import ScaleIndicator from "./leftMenuComponents/scaleIndicator.js";
import RelativitySlider from "./leftMenuComponents/relativitySlider.js";
import ResetLandData from "./leftMenuComponents/resetLandData.js";
import LayersPanel from "./leftMenuComponents/layersPanel";
import TransparencySlider from "./../modals/TransparencySlider.js";

const LeftMenu = ({
  isSelectingLandtypes,
  LandtypeSelectionCancelOnClick,
  toggleDrawer,
  isLeftDrawerOpen,
  isLeftSubDrawerOpen,
  selectedMetric,
  setSelectedMetric,
  PieChartselectionCancelOnClick,
  ModifySelectionCancelOnClick,
  selectedYearEditing,
  setSelectedYearEditing,
  isViewingPieChart,
  isViewingForecast,
  isModifying,
  handleModifyClick,
  isLanduse,
  handleLandUseClick,
  isComparing,
  handleCompareClick,
  globalState,
  globalRefs,
  loggedInToAPI,
  ResetMap,
  longstandingGeoJSONRef,
  selectedLandTypes,
  handleLandtypePTagClick,
  universalParcelDifferentiator,
  universalColorPaletteName,
  landKeySelectedKey,
  setLandKeySelectedKey,
  polygonCustomLayerRef,
  ResetMapToOriginalData,
  endDrawOnClick,
  beginDrawOnClick
}) => {

  let setConvertingData = globalState.setConvertingData;
  let setIsCreateAccountPopupVisible = globalState.setIsCreateAccountPopupVisible;
  let universalDataLoaded = globalState.universalDataLoaded;
  let adminUser = globalState.adminUser;
  let mapRef = globalRefs.mapRef;
  let activeLayer = globalState.activeLayer;

  let isWorkingWithinRealm = globalState.isWorkingWithinRealm;
  let setIsWorkingWithinRealm = globalState.setIsWorkingWithinRealm;

  let isRealmLeftClickedInfoVisible = globalState.isRealmLeftClickedInfoVisible;
  let setIsRealmLeftClickedInfoVisible = globalState.setIsRealmLeftClickedInfoVisible;

  // initially check for data

  let noData = true;

  if (!longstandingGeoJSONRef.current) {
    noData = true;
  } else {
    noData = false;
  }

  const openConverterPortal = () => {
    setConvertingData(true);
  };

  // initially check for data end

  const mobileStatus = isMobile ? "mobile" : "not-mobile";

  return (
    <div className="leftMenuButton">
      <MobileView>
        {isTablet && (
          <button className="togglerDrawInside not-mobile" onClick={toggleDrawer}>
            <IoIosArrowForward />
          </button>
        )}
      </MobileView>

      <BrowserView>
        <button
          className={`togglerDrawInside ${mobileStatus}`}
          onClick={toggleDrawer}
        >
          <IoIosArrowForward />
        </button>
      </BrowserView>

      {!noData ? (
        <Drawer
          open={isLeftDrawerOpen}
          direction="left"
          className="leftMenu"
          enableOverlay={false}
          duration={250}
        >
          <>
            {/* <>
              <h2>SELECT CATEGORY</h2>
              <KeyDropdown
                globalRefs={globalRefs}
                globalState={globalState}
                ResetMap={ResetMap}
              />
            </> */}

            <div className="leftMenuDivider" />

            {/* <h2>SELECT VALUE</h2>
            <ValueDropdown
              resetMetric={resetMetric}
              setSelectedMetric={setSelectedMetric}
              selectedMetric={selectedMetric}
              globalState={globalState}
              ResetMap={ResetMap}
              globalRefs={globalRefs}
              selectedYearEditing={selectedYearEditing}
              universalDataLoaded={universalDataLoaded}
            /> */}

            <div className="leftMenuDivider" />

            {/* {!isWorkingWithinRealm ? ( */}
            <>
              {/* <h2>SELECT YEAR</h2>
              <YearDropdown
                selectedMetric={selectedMetric}
                isModifying={isModifying}
                selectedYearEditing={selectedYearEditing}
                globalState={globalState}
                globalRefs={globalRefs}
                setSelectedYearEditing={setSelectedYearEditing}
                ResetMap={ResetMap}
                setIsCreateAccountPopupVisible={
                  setIsCreateAccountPopupVisible
                }
              /> */}
              {/* <Modify
                ModifySelectionCancelOnClick={
                  ModifySelectionCancelOnClick
                }
                isViewingForecast={isViewingForecast}
                handleModifyClick={handleModifyClick}
                isModifying={isModifying}
              /> */}

              <div className="leftMenuDivider" />

              {/* <PieChart
                PieChartselectionCancelOnClick={
                  PieChartselectionCancelOnClick
                }
                isViewingPieChart={isViewingPieChart}
              />

              <Modify
                ModifySelectionCancelOnClick={
                  ModifySelectionCancelOnClick
                }
                isViewingForecast={isViewingForecast}
                handleModifyClick={handleModifyClick}
                isModifying={isModifying}
              />

              <LandUseButton
                handleLandUseClick={handleLandUseClick}
                isLanduse={isLanduse}
              />

              <CompareButton
                handleCompareClick={handleCompareClick}
                isComparing={isComparing}
              /> */}

              <LayersPanel
                globalRefs={globalRefs}
                globalState={globalState}
                endDrawOnClick={endDrawOnClick}
                beginDrawOnClick={beginDrawOnClick}
              />

              {/* <LandUseButton
                handleLandUseClick={handleLandUseClick}
                isLanduse={isLanduse}
              /> */}

              <TransparencySlider
                globalRefs={globalRefs}
                globalState={globalState}
              />

              <RelativitySlider
                globalRefs={globalRefs}
                globalState={globalState}
              />

              <ScaleIndicator
                isComparing={isComparing}
                handleCompareClick={handleCompareClick}
                mapRef={mapRef}
                globalState={globalState}
                globalRefs={globalRefs}
              />

              <ResetLandData
                isComparing={isComparing}
                handleCompareClick={handleCompareClick}
                mapRef={mapRef}
                globalRefs={globalRefs}
                globalState={globalState}
              />

            </>
          </>

          {!isLeftSubDrawerOpen && (
            <button
              className="togglerDrawOutside"
              onClick={toggleDrawer}
            >
              <IoIosArrowBack />
            </button>
          )}
        </Drawer>
      ) : (
        <div className="noData">
          {/* <div className="noDataText">
            <h2>Loading...</h2>
            <MoonLoader color="#29645D" size={50} speedMultiplier={0.5} />
            <p>It looks like you haven't loaded any data yet!</p>
            <div
              className="leftMenuConverterButton"
              onClick={openConverterPortal}
            >
              Upload Data
            </div>
            <p>or</p>
            <p>Press Load in the Menu above</p>
          </div> */}
        </div>
      )
      }
    </div >
  );
};

export default LeftMenu;